import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('/images/hero-restaurant.jpg')",
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-accent-300">
            Trusted by 2,500+ restaurants worldwide
          </span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight mb-5">
          Smart Restaurant POS
          <br />
          for <span className="text-accent-400">Modern Dining</span>
        </h1>

        <p className="text-sm md:text-base lg:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          Empower your restaurant with QR code self-ordering, a real-time Kitchen
          Display System, and the Captain App for seamless floor management. One
          platform, everything you need.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate("/login")}
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            Start 7-Day Free Trial
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <a
            href="#how-it-works"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector("#how-it-works");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-background-50 border-2 border-background-50/30 hover:bg-background-50/10 rounded-md transition-all whitespace-nowrap cursor-pointer"
          >
            See How It Works
            <i className="ri-play-circle-line ml-2"></i>
          </a>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-6 md:gap-10 max-w-lg mx-auto">
          {[
            { value: "2.5K+", label: "Restaurants" },
            { value: "50M+", label: "Orders Processed" },
            { value: "99.9%", label: "Uptime" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-300 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a
          href="#features"
          onClick={(e) => {
            e.preventDefault();
            const el = document.querySelector("#features");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/40 text-background-50/80 hover:bg-background-50/10 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line"></i>
        </a>
      </div>
    </section>
  );
}